import { render, staticRenderFns } from "./FAQDetails.vue?vue&type=template&id=72fcab77&scoped=true&"
import script from "./FAQDetails.vue?vue&type=script&lang=js&"
export * from "./FAQDetails.vue?vue&type=script&lang=js&"
import style0 from "./FAQDetails.vue?vue&type=style&index=0&id=72fcab77&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fcab77",
  null
  
)

export default component.exports